import styled from "styled-components";
import Button from "components/atoms/Button";
import Modal from "components/atoms/Modal";
import { ReactComponent as ChevronDownIcon } from "assets/images/chevron-down-new.svg";

import media from "helpers/media";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2.4rem;
  margin: 0 auto;
  width: 100vw;
  padding: 2rem 10rem;
  ${media.SM`
  padding: 1rem 1rem;
`}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 2.4rem;
  width: 100%;
  height: 2.4rem;
`;

export const Muted = styled.span`
  color: ${({ theme }) => theme.colors.manatee};
  font-weight: 400;
`;

export const BackButton = styled.button`
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.4rem;
  height: 2.4rem;

  svg {
    width: 2rem;
    height: 2rem;
    stroke: ${({ theme }) => theme.colors.mineShaft};
  }
`;

export const HeaderTitle = styled.h1`
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 1.8rem;
  line-height: 2.1rem;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.mineShaft};
  margin: 0;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const WelcomeSection = styled.div`
  ${media.SM`
    display: none;
  `}
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  gap: 46.8rem;
`;

export const DownloadButton = styled(Button)`
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 2.4rem;
  letter-spacing: 0.02rem;
  padding: 1.2rem;
  align-self: flex-end;
  width: 28rem;
  height: 5.6rem;
  border-radius: 10rem;
  border: 1.5px solid ${({ theme }) => theme.colors.blueHaze};
`;

export const MainContent = styled.div`
  display: flex;
  gap: 2.4rem;
  width: 100%;
  margin-bottom: 2rem;
`;

export const InterestInventorySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  padding: 1.6rem 3.2rem;
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 0.8rem;

  > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const SectionTitle = styled.h3`
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  font-size: 1.4rem;
  line-height: 1.6rem;
  color: #59626c;
  letter-spacing: 0.12rem;
  color: ${({ theme }) => theme.colors.manatee};
  margin: 0;
`;

export const DetailsButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.6rem 1.6rem 0.6rem 1.2rem;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.geyser};
  border-radius: 0.4rem;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 2.4rem;
  letter-spacing: 0.02rem;
  color: ${({ theme }) => theme.colors.mineShaft};
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.colors.manatee};
  }
`;

export const InfoIcon = styled.div`
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.denim};
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: "i";
    color: ${({ theme }) => theme.colors.white};
    font-size: 1rem;
    font-weight: bold;
  }
`;

export const ChartContainer = styled.div`
  display: flex;
  width: 100%;
  position: relative;
`;

export const BarChartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding-left: 19.9rem;
`;

export const MobileInterestChartWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BarItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.8rem;
  height: 2rem;
`;

export const BarFill = styled.div<{ score: number }>`
  height: 1.6rem;
  background: ${({ theme }) => theme.colors.denim};
  border-radius: 0 0.2rem 0.2rem 0;

  opacity: ${({ score }) => {
    if (score >= 70) return 1;
    if (score >= 60) return 0.9;
    if (score >= 55) return 0.8;
    if (score >= 50) return 0.7;
    if (score >= 45) return 0.6;
    if (score >= 40) return 0.5;
    if (score >= 30) return 0.4;
    if (score >= 20) return 0.3;
    return 0.2;
  }};
  width: ${({ score }) => {
    const maxWidth = 23.3;
    return `${(score / 70) * maxWidth}rem`;
  }};
`;

export const BarValue = styled.span`
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.2rem;
  color: ${({ theme }) => theme.colors.mineShaft};
  min-width: 2rem;
  text-align: left;
`;

export const CategoryLabelsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 0.9rem;
  position: absolute;
  left: 0;
  top: 0.3rem;
`;

export const CategoryLabel = styled.div`
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 0.9rem;
  line-height: 1.1rem;
  letter-spacing: 0.04rem;
  text-transform: uppercase;
  text-align: right;
  color: ${({ theme }) => theme.colors.mineShaft};
  height: 1.5rem;
  display: flex;
  align-items: center;
`;

export const AptitudeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  padding: 1.6rem 3.2rem 3.2rem;
  flex: 1;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 0.8rem;
`;

export const PlaceholderCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2.4rem;
  padding: 1.6rem 6.4rem;
  width: 40.4rem;
  background: ${({ theme }) => theme.colors.solitude};
  border-radius: 0.8rem;
`;

export const BooksIconWrapper = styled.div`
  width: 7.2rem;
  height: 7.2rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const PlaceholderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3.2rem;
  width: 100%;
`;

export const PlaceholderTitle = styled.h4`
  font-family: "Roboto Slab", serif;
  font-weight: 600;
  font-size: 2rem;
  line-height: 2.4rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.mineShaft};
  margin: 0;
  white-space: pre-line;
`;

export const PlaceholderText = styled.p`
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 2rem;
  letter-spacing: 0.02rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.mineShaft};
  margin: 0;
`;

export const AssessmentsButton = styled(Button)`
  width: 27.1rem;
  height: 5.6rem;
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 2.4rem;
  padding: 1.1rem 5.8rem;
  border-radius: 10rem;
  box-shadow: 0px 3px 6px rgba(51, 51, 51, 0.16);
`;

export const DetailsText = styled.span`
  ${media.SM`
    display: none;
  `}
`;

// Pricing Cards Section
export const PricingCardsSection = styled.div`
  display: flex;
  ${media.SM`
  flex-direction: column;
`}
  gap: 2rem;
  padding: 1.6rem 0;
  width: 100%;
`;

export const PricingCardsHeader = styled.header`
  font-size: 3.2rem;
  align-self: start;
  font-family: "Roboto Slab", sans-serif;
  ${media.SM`
  font-size: 2.4rem;
`}
`;

export const MobileInterestWrapper = styled.div`
  display: none;
  ${media.SM`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 0.6rem;
`};
  @media print {
    display: none;
  }
`;

export const ShowMoreButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 1.5rem;
  justify-content: center;
`;

export const ShowMoreButton = styled.button`
  color: ${({ theme }) => theme.colors.denim};
  font-size: 2rem;
`;

export const ChevronDown = styled(ChevronDownIcon)`
  min-width: 2rem;
  path {
    stroke: ${({ theme }) => theme.colors.denim};
  }
`;

export const InterestModal = styled(Modal)`
  width: 100%;
  max-width: 120rem;
  height: 100%;
  max-height: 80rem;
`;

export const InterestItem = styled.div`
  font-size: 1.8rem;
  margin-bottom: 1rem;
`;

export const InterestModalContent = styled.div`
  max-height: 80vh;
  overflow-y: auto;
`;
